module.exports = __webpack_public_path__ + "static/media/drl3.png.4302430a.jpg";